import type { JSX } from "react";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import type * as THREE from "three";
import { useSceneStore } from "@/state/useSceneStore";

interface LightSpec {
  pos: [number, number, number];
}

const LIGHTS: LightSpec[] = [
  { pos: [-0.2, 0.6, 0.24] },
  { pos: [-0.2, 0.6, 0.42] },
  { pos: [-0.2, 0.6, 0.01] },
  { pos: [-0.2, 0.6, -0.14] },
];

const COLOR = 0xff0000;
const DISTANCE = 1.1;
const DARK_INTENSITY = 0.6;
const LIGHT_INTENSITY = 0;
const FADE_DURATION = 0.6;

export const WallLights = (): JSX.Element => {
  const theme = useSceneStore((s) => s.theme);
  const refs = useRef<(THREE.PointLight | null)[]>([]);

  useEffect(() => {
    const target = theme === "dark" ? DARK_INTENSITY : LIGHT_INTENSITY;
    const tweens = refs.current
      .filter((l): l is THREE.PointLight => l !== null)
      .map((l) => gsap.to(l, { intensity: target, duration: FADE_DURATION }));
    return () => {
      tweens.forEach((t) => t.kill());
    };
  }, [theme]);

  const initialIntensity =
    theme === "dark" ? DARK_INTENSITY : LIGHT_INTENSITY;

  return (
    <>
      {LIGHTS.map((spec, i) => (
        <pointLight
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          position={spec.pos}
          color={COLOR}
          intensity={initialIntensity}
          distance={DISTANCE}
        />
      ))}
    </>
  );
};
